import React, { useEffect } from "react";
import {sha256} from '../library/comoda'

interface TextBoxProps {
    id: string
    name?: string
    class?:string
    type?: string
    valore: string
    placeholder?: string
    setValore: (v : string) => void
}

const TextBox: React.FC<TextBoxProps> = ({
    type='text',
    placeholder,
    setValore
}) => {
    const instradeOutput= async (type : string, value : string) =>{
            if(type === 'password'){
                setValore(await sha256(value))
                
            }
            else{
                setValore(value)
            }
    }


  useEffect(() => {
  }, []); // Runs only once after the initial render.

  return (
    <div>
    <input 
        className="textBox"
        type={type}
        placeholder={placeholder}
        onChange={(event : React.ChangeEvent<HTMLInputElement>) => instradeOutput(type,event.target.value)}

    ></input>
    </div>
  );
};

export default TextBox;

